module.exports = __webpack_public_path__ + "media/main.ac049bde.mp4";